<template>
    <div v-if="message" class="mb-4 font-medium text-sm text-green-600">
        {{ message }}
    </div>

    <form v-else @submit.prevent="submit">
        <FormGroup name="email" label="Email">
            <Input
                name="email"
                ref="email"
                type="email"
                v-model="form.email"
                required/>
        </FormGroup>

        <div class="flex items-center justify-end mt-4">
            <router-link
                :to="{name: 'login'}"
                class="underline text-sm text-gray-600 hover:text-gray-900">
                Know your password?
            </router-link>
            <SubmitButton
                class="ml-4"
                :submitting="form.processing"
                :disabled="form.errors.any()">
                Email Password Reset Link
            </SubmitButton>
        </div>
    </form>
</template>

<script>

import FormGroup from "@/Components/Form/FormGroup";
import Input from "@/Components/Form/Input";
import SubmitButton from "@/Components/Form/SubmitButton";

export default {

    name: "ForgotPasswordForm",

    data() {
        return {
            message: '',
            form: this.$form({
                email: ''
            })
        }
    },

    emits: ['success'],

    provide() {
        return {
            form: this.form
        };
    },

    components: {
        SubmitButton,
        FormGroup,
        Input
    },

    methods: {
        focus() {
            this.$refs.email.focus();
        },
        submit() {
            this.form.post(route('password.email'))
                .then(({message}) => {
                    this.message = message;
                    this.$emit('success');
                })
                .catch(console.error)
        }
    },
}
</script>
